module.exports = __webpack_public_path__ + "static/pic03-998b37fb4269d5bd6f6de7702d19d95c.jpg";